export default {
  get: {
    // 获取全部系统
    getList: '/api/system/list',
    // 获取我的常用系统
    getMyList: '/api/system/my-list',
    // 搜索
    getSearch: '/api/search/list',
    // 获取用户信息
    getUserInfo: '/api/user/get-user-info',
    // 获取待办事项
    getTodoList: '/api/user/todo-count',
    // 获取helpdesk列表
    getHelpdeskList: '/api/helpdesk/list',
    // 获取制度列表
    getRuleList: '/api/kms/get-rule-list',
    // 获取云杉新闻
    getNewList: '/api/ins/new-list',
    // 公告列表
    getNoticeList: '/api/notice/list',
    // 获取helpdesk联系人列表
    getHelpdeskContact: '/api/helpdesk/business-link-list',
    // 获取钉钉公告
    getBlackboardList: '/api/notice/tips?size=3',
    getSearchKwTop: '/api/helpdesk/search-kw-top',
    getLeaderInfo: '/api/user/get-leader-info'
  },
  post: {
    saveSystem: '/api/system/save',
    delSystem: '/api/system/del'
  }
}
